import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import React from 'react';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';

var renderChildren = function (children, isCollapsed, onClick) {
    var childrenLength = children.length;
    var separator = React.createElement(Icon, { iconName: Icons.NavArrowRight, className: "dsb-breadcrumbs__separator-icon", size: "small" });
    if (!isCollapsed) {
        return children === null || children === void 0 ? void 0 : children.reduce(function (res, link, i) {
            res.push(React.createElement("li", { className: "dsb-breadcrumbs__item", key: i }, link));
            if (i < childrenLength - 1) {
                res.push(React.createElement("li", { className: "dsb-breadcrumbs__separator", key: "".concat(i).concat(separator) }, separator));
            }
            return res;
        }, []);
    }
    return [
        React.createElement("li", { className: "dsb-breadcrumbs__item", key: 'a' }, children === null || children === void 0 ? void 0 : children[0]),
        React.createElement("li", { className: "dsb-breadcrumbs__separator", key: 'b' }, separator),
        React.createElement(Typography, { className: "dsb-breadcrumbs__dots", variant: 'body3', key: 'c', onClick: onClick }, "..."),
        React.createElement("li", { className: "dsb-breadcrumbs__separator", key: 'd' }, separator),
        React.createElement("li", { className: "dsb-breadcrumbs__item", key: 'e' }, children === null || children === void 0 ? void 0 : children[childrenLength - 1])
    ];
};

export { renderChildren };
